<template>
  <div class="edit-fair-wrap">
    <h2>Domains</h2>
    <div class="new-domain-wrap">
      <div class="label-input">
        <label for="domain-name">Set new domain:</label>
        <input type="text" id="domain-name" v-model.trim="domainName">
      </div>
      <button @click="setDomain">Add new domain</button>
    </div>
    <p>List of all domains:</p>
    <each-domain
      v-for="domain in domains"
      :key="domain.dom_id"
      :domain="domain"
      @add-ssl="addSSL"
      @set-domain="setDomain"
      @delete-domain="confirmDelete"
    >
    </each-domain>
  </div>
</template>

<script>
import EachDomain from './EachDomain'
import AdminMixin from '../../../views/admin-pages/adminMixin'
import api from '@/api'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    EachDomain
  },
  props: {
    fair: Object
  },
  data () {
    return {
      domains: [],
      domainName: '',
      domIdToDelete: null
    }
  },
  mounted () {
    if (this.fair) {
      this.startLoading();
        this.getDomains();
      this.stopLoading();
    }
  },
  methods: {
    async getDomains () {
      let apiObj = {
        api: api.getDomainForSite,
        params: {
          sit_id: this.fair.sit_id
        },
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);

      if (data) {
        this.domains = data.data.domains.reverse();
      }
    },
    async addSSL (domId) {
      let params = {
        dom_id: domId
      }
      await this.callApiShowMessageGetData(api.setSSLforDomain, params, this.$t('superAdmin.sslAdded'))
    },
    async setDomain () {
      if (!this.domainName) {
        this.handleError(new Error(this.$t('superAdmin.emptyDomainError')))
        return;
      }

      let params = {
        sit_id: this.fair.sit_id,
        dom_name: this.domainName
        // dom_name: this.domainName + '.testvf1.mt.milanskaric.com'
      }

      await this.callApiShowMessageGetData(api.setDomain, params, this.$t('superAdmin.domainSet'))
    },
    confirmDelete (domId) {
      this.domIdToDelete = domId;
      this.confirmAction(this.deleteDomain, this.$t('superAdmin.domainDeleteQuestion'));
    },
    async deleteDomain () {
      let params = {
        sit_id: this.fair.sit_id,
        dom_id: this.domIdToDelete
      }
      await this.callApiShowMessageGetData(api.deleteDomain, params, this.$t('superAdmin.domainDeleted'))
    },
    async callApiShowMessageGetData(api, params, successMessage) {
      let apiObj = {
        api: api,
        params: params,
        onError: () => this.stopLoading()
      }
      
      this.startLoading();
        const data = await this.apiCall(apiObj);
        if (data.result !== "ERR") {
          await this.getDomains();
          this.showSuccessMessage(successMessage);
        }
      this.stopLoading();
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.edit-fair-wrap {
  background: #FFF;
  position: relative;
  width: 100%;
}
.new-domain-wrap {
  display: flex;
  align-items: flex-end;
}
.label-input {
  width: 80%;
  margin-right: 20px;
}
.new-domain-wrap button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
}
</style>